import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NotificationService } from '../../../../../core/services/notification/notification.service';
import { ToastComponent } from '../../../../shared/toast/toast.component';
import { NotificationContentModel } from '../../../../../core/models/notification/notification-content.model';
import { TranslationModel } from '../../../../../core/models/notification/notification-content-language.model';
import { FullscreenOverlayComponent } from '../../../../components/fullscreen-overlay/fullscreen-overlay.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-edit-email-notification',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FullscreenOverlayComponent,
    TranslateModule,
  ],
  templateUrl: './edit-email-notification.component.html',
  styleUrl: './edit-email-notification.component.scss',
})
export class EditEmailNotificationComponent {
  notificationForm: FormGroup;
  notificationId: string = '';
  showToast: boolean = false;
  toastMessage: string = '';
  toastType: 'success' | 'error' | 'warning' = 'success';
  notificationContent: NotificationContentModel = {
    id: '',
    notificationType: 0,
    translations: [
      {
        translationId: '',
        subject: '',
        body: '',
        languageCode: '',
        notificationTemplateId: '',
      },
    ],
  };
  notificationContentEn: TranslationModel | any = {
    translationId: '',
    subject: '',
    body: '',
    languageCode: '',
    notificationTemplateId: '',
  };
  notificationContentNl: TranslationModel | any = {
    translationId: '',
    subject: '',
    body: '',
    languageCode: '',
    notificationTemplateId: '',
  };
  isOverlayLoading: boolean = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    private translate: TranslateService
  ) {
    this.notificationForm = this.fb.group({
      subjectEn: ['', [Validators.required]],
      bodyEn: ['', [Validators.required]],
      subjectNl: ['', [Validators.required]],
      bodyNl: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.notificationId = this.route.snapshot.paramMap.get('id')!;
    this.notificationContent = history.state.notification;
    this.notificationContentEn = this.notificationContent.translations.find(
      (item: any) => item.languageCode === 'en'
    );
    this.notificationContentNl = this.notificationContent.translations.find(
      (item: any) => item.languageCode === 'nl'
    );
    this.notificationForm.patchValue({
      subjectEn: this.notificationContentEn.subject,
      bodyEn: this.notificationContentEn.body,
      subjectNl: this.notificationContentNl.subject,
      bodyNl: this.notificationContentNl.body,
    });
  }

  saveNotification(e: Event) {
    e.preventDefault();

    if (this.notificationId) {
      // Edit notification
      if (this.notificationForm.valid) {
        const formData = {
          id: this.notificationId,
          translations: [
            {
              translationId: this.notificationContentEn.translationId,
              languageCode: this.notificationContentEn.languageCode,
              subject: this.notificationForm.value.subjectEn,
              body: this.notificationForm.value.bodyEn,
            },
            {
              translationId: this.notificationContentNl.translationId,
              languageCode: this.notificationContentNl.languageCode,
              subject: this.notificationForm.value.subjectNl,
              body: this.notificationForm.value.bodyNl,
            },
          ],
        };

        this.notificationService
          .editNotificationTemplate(this.notificationId, formData)
          .subscribe({
            next: () => {
              this.isOverlayLoading = true;
              this.showToast = false;
              setTimeout(() => {
                this.displayToast(
                  true,
                  'Notification has been edited successfully',
                  'success'
                );
              }, 0);
              setTimeout(() => {
                this.router.navigate(['/notification-contents/email']);
              }, 2000);
            },
            error: () => {
              this.displayToast(
                true,
                'Error occured while editing the notification.',
                'error'
              );
            },
          });
      } else {
        this.showToast = false;
        setTimeout(() => {
          this.displayToast(
            true,
            'All fields are required and must be filled with valid values',
            'warning'
          );
        }, 0);

        this.notificationForm.markAllAsTouched();
      }
    }
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.notificationForm.get(controlName);
    return control ? control.invalid && control.touched : false;
  }

  displayToast(show: boolean, message: string, type: string | any) {
    this.showToast = show;
    this.toastMessage = message;
    this.toastType = type;
  }
}
